import Vue from "vue";

export const setAllConsumedApis = (state, data) => {
    state.allConsumedApis = data;
};

export const setAllInternalApis = (state, data) => {
    state.allInternalApis = data;
};

export const setAllExposedApis = (state, data) => {
    state.allExposedApis = data.data;
};

export const setAllStartsFromExternal = (state, data) => {
    state.startExternalSource = data.data;
};

export const deleteConsumedApi = (state, item) => {
    state.allConsumedApis.splice(state.allConsumedApis.findIndex(elem => elem.id === item.id), 1);
};

export const refreshConsumedApi = (state, item) => {
    const index = state.allConsumedApis.findIndex(element => element.id === item.id);
    if (index !== -1) {
        if (item.webServiceMethods) {
            state.allConsumedApis[index].webServiceMethods = [];
            state.allConsumedApis[index].webServiceMethods.push(...item.webServiceMethods);
        }
        if (item.url) {
            state.allConsumedApis[index].url = item.url;
        }
    }
};

export const setUpdatedExposedApi = (state, data) => {
    const updateElemIndex = state.allExposedApis.findIndex(elem => data.id === elem.id);
    if (updateElemIndex !== -1) {
        Vue.set(state.allExposedApis, updateElemIndex, data);
    } else {
        state.allExposedApis.unshift(data);
    }
};
export const clearEditAddConsumedMark = (state, data) => {
    if (data.prop === "temporary") {
        const dataSaved = data.data;
        dataSaved.forEach(api => {
            for (let i = 0; i < state.allConsumedApis.length; i++) {
                if (state.allConsumedApis[i].givenName === api.givenName) {
                    state.allConsumedApis[i].id = api.id;
                    break;
                }
            }
        });
    }

    state.allConsumedApis = state.allConsumedApis.map(consumedApi => {
        const apiClone = { ...consumedApi };
        if ((apiClone && apiClone.hasOwnProperty(data.prop))) {
            delete apiClone[data.prop];
        }
        return apiClone;
    });
};

export const deleteExposedApi = (state, item) => {
    state.allExposedApis.splice(state.allExposedApis.findIndex(elem => elem.id === item.id), 1);
};

export const setNewConsumedApi = (state, data) => {
    state.allConsumedApis.splice(0, 0, data);
};

export const enableConsumedAPIDownload = (state) => {
    state.allConsumedApis.forEach(api => {
        if (api.consumedApiNotSavedYet) {
            api.consumedApiNotSavedYet = false;
        }
    });
};

export const setAllExposedApi = (state, data) => {
    state.allExposedApis = data.data.object.map(exposedApi => {
        const newClone = { ...exposedApi };
        if ((newClone && newClone.hasOwnProperty(data.temporary))) {
            delete newClone.temporary;
        }
        return newClone;
    });
};

export const setNewExposedApi = (state, data) => {
    state.allExposedApis.splice(0, 0, data);
};

export const setDownloadFile = (state, data) => {
    let exportObj;
    switch (data.headers.contentType) {
        case "text/plain":
        case "application/json":
            exportObj = JSON.stringify(data.data);
            break;
        case "application/xml":
        case "text/x-yaml":
            exportObj = data.data;
            break;
        default:
            exportObj = null;
    }
    let filename = data.headers.contentDisposition.replace(/"/g, "");
    filename = filename.substring(filename.indexOf("=") + 1);
    const file = new Blob([exportObj], {
        type: data.headers.contentType
    });
    if (window.navigator.msSaveOrOpenBlob) {
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
    } else {
        // Others
        const a = document.createElement("a");
        const url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
    }
};
export const setApiCommitId = (state, payload) => {
    state.apiCommitId = payload;
};

export const setExposedApiCommitId = (state, payload) => {
    state.exposedApiCommitId = payload;
};
